var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mamnoon"},[_c('Nav'),_c('UpserveOloRetail',{attrs:{"title":'Mamnoon',"oloEndpoint":'/oloorderretail',"menuEndpoint":'/product/upserveolo',"emailAddress":_vm.$store.state.currentUserEmail}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }